module.exports = __webpack_public_path__ + "static/clinton-b98c2a44846521bdc715047b25634641.jpg";